import { createFileRoute } from '@tanstack/react-router';
import MetadataFieldMapsComponent from 'src/Administration/Metadata/MetadataFieldMaps/MetadataFieldMaps';

export const Route = createFileRoute('/systemadmin/_layout/metadata/field-maps/')({
  component: MetadataFieldMapsComponent,
});
